<div class="auth-fullpage">
  <div id="logo-container" [@fadeInGlideUp]="authService.animationDuration">
    <app-logo width="217px" height="48px" class="svg-bold"></app-logo>
  </div>

  <div
    id="component-container"
    class="position-relative"
    [@fadeInGlideDown]="authService.animationDuration"
  >
    <c-card
      id="component-view-port"
      class="w-30 p-3 position-absolute top-50 start-50 translate-middle-x"
    >
      <c-card-body>
        @if (checkingAuth) {
          <div class="d-flex justify-content-center align-items-center" style="min-height: 200px;">
            <c-spinner color="primary"></c-spinner>
          </div>
        } @else {
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <app-alert-message [parentComponent]="this"></app-alert-message>

            <app-control-input-user
              formControlName="username"
              [placeholder]="'AUTH_LOGIN_PLACEHOLDER_USERNAME'"
            >
            </app-control-input-user>
            <app-control-input-password
              formControlName="password"
              [placeholder]="'AUTH_LOGIN_PLACEHOLDER_PASSWORD'"
              [showVisibilityToggle]="false"
            >
            </app-control-input-password>
            <app-control-button-submit
              [parentComponent]="this"
              [buttonText]="'AUTH_LOGIN_BUTTON_LOGIN'"
              [disabled]="authService.submitButtonIsDisabled(this)"
              [icon]="icons.chevronLeft.name"
              [iconSize]="icons.chevronLeft.size"
            ></app-control-button-submit>
            <c-input-group class="d-grid flex-nowrap px-2">
              @if (forgotPasswordLinkVisible) {
                <c-nav variant="underline-border">
                  <a
                    [routerLink]
                    (click)="showForgetPassword()"
                    cNavLink
                    [disabled]="authService.actionInProgress(this)"
                  >
                    {{ 'AUTH_LOGIN_BUTTON_FORGOT_PASSWORD' | translate }}
                  </a>
                </c-nav>
              }
            </c-input-group>
          </form>
        }
      </c-card-body>
    </c-card>
  </div>
</div>
